const TPLogoMobile = () => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="tp-logo-mobile">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.95843 0H12.8313L6.00978 15.511H2.13692L8.95843 0ZM2.22005 4.49878H6.09291L3.87286 9.54523H0L2.22005 4.49878ZM11.7408 4.49878L4.9242 20H8.79706L15.6137 4.49878H11.7408ZM12.8509 12.802L17.0513 3.24694H20.9242L16.7237 12.802H12.8509Z" fill="#3177FF"/>
    </svg>
  );
};

export default TPLogoMobile;
